import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

interface SimpleComponentProps {
    label: string;
}

@Dce("simple")
export default class SimpleComponent extends DceComponent<SimpleComponentProps> {
    constructor(elem: DceHTMLElement, props: SimpleComponentProps) {
        super(elem, props);
        console.log("Props", props);
    }
}
